<template>
  <div class="page">
    <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'5px'}">
      <custom-paging-dragging-list
        ref="table"
        rowKey="commodityBrandId"
        :columns="columns"
        :queryParams="queryParams"
        :requestPromise="loadPromise"
        @draggable="onDraggable"
      >
        <div slot="indexSlots" slot-scope="data">{{ data.index + 1 }}</div>
        <div class="image-table" slot="imageSlots" slot-scope="data">
          <CustomImage :imageUrl="data.record.proImg" :width="120"></CustomImage>
        </div>
      </custom-paging-dragging-list>
    </a-card>
  </div>
</template>

<script>
import CustomPagingDraggingList from '@/customComponents/CustomPagingDraggingList/CustomPagingDraggingList'

export default {
  name: 'CommodityBrandSaleList',
  components: {
    CustomPagingDraggingList
  },
  props: {
    iconId: {
      type: String | Number,
      default: ''
    },
    commodityType: {
      type: String | Number,
      default: ''
    },
    crossBorderDirect: {
      type: String | Number,
      default: ''
    }
  },
  data() {
    return {
      queryParams: {},
      loadPromise: params => this.getListPromise(params),
      hotProList: [],
      columns: [
        {
          title: '排序',
          dataIndex: 'index',
          scopedSlots: { customRender: 'indexSlots' }
        },
        {
          title: '品牌ID',
          dataIndex: 'commodityBrandId'
        },
        {
          title: '封面图片',
          dataIndex: 'proImg',
          scopedSlots: { customRender: 'imageSlots' }
        },
        {
          title: '品牌名称',
          dataIndex: 'commodityBrandName'
        }
        // {                  未发现使用，隐藏  ---- DX
        //   title: '操作',
        //   dataIndex: 'action',
        //   width: '100px',
        //   scopedSlots: { customRender: 'action' }
        // }
      ]
    }
  },
  mounted() {

  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      params.iconId = this.iconId ? Number(this.iconId) : 0
      params.commodityType = this.commodityType
      params.crossBorderDirect = this.crossBorderDirect
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getUserService().post('homepage/icon/queryCommodityTypeBrandSection', params)
    },
    // 拖拽排序功能
    onDraggable(params) {
      this.getLogUtils().logWithTag('==onDraggable排序==', params)
      let idList = new Array
      idList = params.dataList.map((item) => {
        return item.commodityBrandId
      })
      if (this.iconId == 0 || this.iconId == '0') {
        this.$emit('onDraggableChange', {
          idList: idList,
          pageNum: params.pageNo,
          pageSize: params.pageSize,
          type: 2
        })
      } else {
        let paramsObj = {
          pageNum: params.pageNo,
          pageSize: params.pageSize,
          idList: idList,
          iconId: this.iconId ? Number(this.iconId) : 0,
          channelType: 2
        }
        this.getLogUtils().logWithTag('==idList==', idList)
        this.getHttpServices().getUserService().post('homepage/icon/save/commodityTypeChannelOrderBy', paramsObj)
          .then(res => {
            this.getLogUtils().logWithTag('==onDraggable==', res)
            this.$message.success('排序成功')
          }).catch(reason => this.showNetWorkErrorMessage(reason))
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../../CustomPage.less');
</style>